import React, { useState, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";
import logo from "../../images/logo.svg"

export default function ReceiptLayoutSettings() {
  const [header, setHeader] = useState("");
  const [footer, setFooter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const schoolName = "Demo School For Development";

  // Fetch header/footer from backend
  useEffect(() => {
    getReceiptSettings();
  }, []);

  const getReceiptSettings = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key,
      language: "en",
    };

    try {
      const response = await simplePostCall(
        ApiConfig.receiptlayout,
        JSON.stringify(requestBody),
      );
      if (response?.result && response?.invoice_layout?.length > 0) {
        const data = response.invoice_layout[0];
        setHeader(data.invoice_header || "");
        setFooter(data.invoice_footer || "");
      }
    } catch (error) {
      console.error("Error fetching receipt settings:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Save layout
  const handleSave = async () => {
    if (!header.trim() || !footer.trim()) {
      toast.warning("Please enter Header and Footer first!");
      return;
    }

    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key,
      user_id: Number(user_id),
      language: "en",
      ReceiptLayout: [
        {
          receipt_layout_header: header,
          receipt_layout_footer: footer,
        },
      ],
    };

    try {
      const response = await simplePostCall(
        ApiConfig.receiptlayout,
        JSON.stringify(requestBody),
      );
      if (response?.result) {
        toast.success("Receipt Layout Saved Successfully!", {
          autoClose: 1500,
        });
        setShowPreview(true);
      } else {
        toast.warning(response?.message || "Failed to save layout.");
      }
    } catch (error) {
      console.error("Error saving receipt layout:", error);
      toast.error("An error occurred while saving.");
    } finally {
      setIsLoading(false);
    }
  };

  const thStyle = {
    border: "1px solid #000",
    padding: "8px",
    textAlign: "left",
  };

  const tdStyle = {
    border: "1px solid #000",
    padding: "8px",
  };

  return (
    <div className="receiplayout-container my-4">
      <ToastContainer />

      <div className="container-fluid">
        <div className="special-header panel-white-all mb-4">
          <h4 className="page-title mt-1">Receipt Layout Settings</h4>
        </div>

        <div className="row">
          {/* ================= LEFT SIDE ================= */}
          <div className="col-md-6">
            <div className="receip-bg p-4 border rounded bg-white">
              <div className="editor-section mb-4">
                <label className="fw-bold mb-2">Enter Receipt Header</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={header}
                  onChange={(event, editor) => setHeader(editor.getData())}
                />
              </div>

              <div className="editor-section mb-4">
                <label className="fw-bold mb-2">Enter Receipt Footer</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={footer}
                  onChange={(event, editor) => setFooter(editor.getData())}
                />
              </div>

              <button
              style={{background: "#5db2e8", border: "none"}}
                className="btn btn-primary w-100"
                onClick={handleSave}
                disabled={isLoading}
              >
                {isLoading ? "Generating PDF..." : "Save & Generate PDF Preview"}
              </button>
            </div>
          </div>

          {/* ================= RIGHT SIDE ================= */}
          <div
            className="col-md-6 p-3 rounded"
            style={{ background: "#f8f9fa", marginTop: "30px" }}
          >
            <h5 className="border-bottom pb-2 mb-3">PDF Receipt Preview</h5>
            {showPreview ? (
              <div
                style={{
                  background: "#f8f9fa",
                  padding: "10px",
                  borderRadius: "8px",
                  height: "500px",
                  overflowY: "auto",
                }}
              >
                {/* A4 Page */}
                <div
                  style={{
                    maxWidth: "500px",
                    margin: "0 auto",
                    background: "#fff",
                    padding: "40px 30px",
                    border: "3px solid #333",
                    minHeight: "610px",
                    position: "relative",
                  }}
                >
                  {/* Logo + School Name */}
                  <div style={{ textAlign: "center", marginBottom: "15px" }}>
                    <img
                      src={logo}
                      alt="logo"
                      style={{ height: "50px", marginBottom: "10px" }}
                    />

                    <div style={{ fontWeight: "700", marginTop: "5px" }}>
                      {schoolName}
                    </div>
                  </div>

                  {/* Header */}
                  <div
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                    dangerouslySetInnerHTML={{
                      __html: header || "Header Content",
                    }}
                  />

                  {/* Invoice Title */}
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "600",
                      marginBottom: "20px",
                    }}
                  >
                    Monthly Addon Subscription Invoice for February-2026
                  </div>

                  {/* Table */}
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "14px",
                    }}
                  >
                    <thead>
                      <tr style={{ background: "#f1f1f1" }}>
                        <th style={thStyle}>Sl.No.</th>
                        <th style={thStyle}>Addon Name</th>
                        <th style={thStyle}>Addon Type</th>
                        <th style={thStyle}>Subscription Price ($)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={tdStyle}>1</td>
                        <td style={tdStyle}>Time Table</td>
                        <td style={tdStyle}>Web</td>
                        <td style={tdStyle}>10</td>
                      </tr>
                      <tr>
                        <td style={tdStyle}>2</td>
                        <td style={tdStyle}>Driver Console</td>
                        <td style={tdStyle}>Mobile</td>
                        <td style={tdStyle}>10</td>
                      </tr>
                      <tr>
                        <td style={tdStyle}>3</td>
                        <td style={tdStyle}>Teacher App</td>
                        <td style={tdStyle}>Mobile</td>
                        <td style={tdStyle}>10</td>
                      </tr>
                      <tr>
                        <td style={tdStyle}>4</td>
                        <td style={tdStyle}>Parent App</td>
                        <td style={tdStyle}>Mobile</td>
                        <td style={tdStyle}>10</td>
                      </tr>

                      {/* Total */}
                      <tr>
                        <td
                          colSpan="3"
                          style={{
                            ...tdStyle,
                            textAlign: "right",
                            fontWeight: "700",
                          }}
                        >
                          Total Amount ($)
                        </td>
                        <td style={{ ...tdStyle, fontWeight: "700" }}>40</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Footer */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      width: "90%",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: footer || "Footer Content",
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                <i className="bi bi-file-pdf" style={{ fontSize: "3rem" }}></i>
                <p>Save changes to generate and Preview PDF</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
